var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catering-item"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.info.logo}})]),_c('div',{staticClass:"info-name"},[_vm._v(_vm._s(_vm.info.name))]),_c('div',[_c('van-button',{attrs:{"round":"","color":"#9774E1","size":"small"},on:{"click":_vm.routerTo}},[_vm._v("立即点餐")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }